export default __webpack_public_path__ + "static/media/sketch14.e94064a5.png";